import { render, staticRenderFns } from "./AboutView.vue?vue&type=template&id=7a203682&scoped=true"
import script from "./AboutView.vue?vue&type=script&lang=js"
export * from "./AboutView.vue?vue&type=script&lang=js"
import style0 from "./AboutView.vue?vue&type=style&index=0&id=7a203682&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a203682",
  null
  
)

export default component.exports